import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import '../PromoCodes.scss'

const t = buildTranslate('promo_codes.create_edit.navbar')

type PromotionFormNavbarProps = {
  isEdit: boolean
  isDraft: boolean
  isSaving: boolean
  hasChanges: boolean
  onCancel: () => void
  onSaveAndExit: () => void
  onSubmit: () => void
  onActivate: () => void
}

const FormNavbar: React.FC<PromotionFormNavbarProps> = ({
  isEdit,
  isDraft,
  isSaving,
  hasChanges,
  onCancel,
  onSaveAndExit,
  onSubmit,
  onActivate,
}) => {
  const showCancel = !isEdit && !hasChanges

  const getButtonLabel = (): string => {
    if (isSaving) return t('saving')
    if (isEdit) return t('save')
    return t('create')
  }

  return (
    <nav aria-label={t('aria_label')} className="promo-navbar">
      <div>
        <Text.BodyText5 className="promo-navbar__label" color="white">
          {t('configure')}
        </Text.BodyText5>
        <Text.BodyText3 bold color="white">
          {t('promo_code')}
        </Text.BodyText3>
      </div>
      <div className="promo-btn-group">
        <Button
          kind="minimal"
          onClick={showCancel ? onCancel : onSaveAndExit}
          disabled={isSaving}
          className="promo-navbar__save-exit"
        >
          {showCancel ? t('cancel') : t('save_and_exit')}
        </Button>
        <Button
          kind="secondary"
          onClick={onSubmit}
          disabled={isSaving}
          className="promo-navbar__create-btn"
        >
          {getButtonLabel()}
        </Button>
        {isDraft && isEdit && (
          <Button
            kind="primary"
            onClick={onActivate}
            disabled={isSaving}
            className="promo-navbar__activate-btn"
          >
            {t('activate')}
          </Button>
        )}
      </div>
    </nav>
  )
}

export default FormNavbar
